/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useContext, useState } from "react";
import {
  Grid,
  TextField,
  Autocomplete,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Button,
  InputAdornment,
} from "@mui/material";
import EuroIcon from "@mui/icons-material/Euro";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import TuneIcon from "@mui/icons-material/Tune";
import ClearIcon from "@mui/icons-material/Clear";
import { Vocabulary } from "../../Utils/Vocabulary";
import { isMobile } from "../../Utils/utils";
import { CacheContext } from "../../Context/cacheContext";

export type XAutoFilters = {
  page: number;
  perPage: number;
  brandId: string | null;
  modelId: string | null;
  minPrice: string | null;
  maxPrice: string | null;
};

interface XAutoFiltersProps {
  filters: XAutoFilters;
  onFilterChange: (updates: Partial<XAutoFilters>) => void;
  onResetFilters: () => void;
}

const XAutoFiltersComponent: React.FC<XAutoFiltersProps> = ({
  filters,
  onFilterChange,
  onResetFilters,
}) => {
  const [accordionOpen, setAccordionOpen] = useState(true);
  const cacheContext = useContext(CacheContext);

  const brands: any[] = cacheContext?.cache?.brands || [];
  const selectedBrand = brands.find((b: any) => b.id == filters.brandId) || null;

  const models: any[] = selectedBrand
    ? (cacheContext?.cache?.models || []).filter(
        (m: any) => m.brand_id === selectedBrand.id
      )
    : [];
  const selectedModel = models.find((m: any) => m.id === filters.modelId) || null;

  const handleBrandChange = (_: any, value: any) => {
    onFilterChange({ brandId: value?.id ?? null, modelId: null });
  };

  const handleModelChange = (_: any, value: any) => {
    onFilterChange({ modelId: value?.id ?? null });
  };

  return (
    <Accordion
      expanded={accordionOpen}
      onChange={() => setAccordionOpen(!accordionOpen)}
      style={{ marginBottom: 20 }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="xauto-filters-content"
        id="xauto-filters-header"
      >
        <TuneIcon style={{ marginRight: 10 }} />
        <Typography style={{ marginTop: 1, fontSize: "1rem" }}>
          {Vocabulary.filters}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={isMobile() ? 2 : 4} style={{ marginBottom: 10 }}>
          <Grid item xs={12} md={6} lg={3}>
            <Autocomplete
              options={brands}
              getOptionLabel={(option: any) => option.nume || ""}
              isOptionEqualToValue={(option:any, value:any) => option?.id == value || option?.id == value?.id}
              value={selectedBrand}
              onChange={handleBrandChange}
              renderInput={(params) => (
                <TextField {...params} label={Vocabulary.brand} size="small" />
              )}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <Autocomplete
              options={models}
              getOptionLabel={(option: any) => option.nume || ""}
              value={selectedModel}
              onChange={handleModelChange}
              renderInput={(params) => (
                <TextField {...params} label={Vocabulary.model} size="small" />
              )}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={6}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                border: "1px solid rgba(0,0,0,0.23)",
                borderRadius: 4,
                padding: "4px 12px",
              }}
            >
              <EuroIcon style={{ color: "#FF6633", fontSize: 18, flexShrink: 0 }} />
              <TextField
                placeholder={Vocabulary.minPrice}
                size="small"
                type="number"
                value={filters.minPrice || ""}
                onChange={(e) => onFilterChange({ minPrice: e.target.value || null })}
                variant="standard"
                InputProps={{ disableUnderline: true }}
                inputProps={{ style: { textAlign: "right" } }}
                style={{ flex: 1 }}
              />
              <Typography style={{ color: "#aaa", flexShrink: 0 }}>—</Typography>
              <TextField
                placeholder={Vocabulary.maxPrice}
                size="small"
                type="number"
                value={filters.maxPrice || ""}
                onChange={(e) => onFilterChange({ maxPrice: e.target.value || null })}
                variant="standard"
                InputProps={{ disableUnderline: true }}
                style={{ flex: 1 }}
              />
              <InputAdornment position="end" style={{ color: "#aaa" }}>
                EUR
              </InputAdornment>
            </div>
          </Grid>
        </Grid>
        <div style={{ marginTop: 15, textAlign: "right" }}>
          <Button
            variant="outlined"
            size="small"
            onClick={onResetFilters}
            startIcon={<ClearIcon />}
            style={{ color: "#FF6633", borderColor: "#FF6633" }}
          >
            {Vocabulary.resetFilters}
          </Button>
        </div>
      </AccordionDetails>
    </Accordion>
  );
};

export default XAutoFiltersComponent;
